/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A single data point in a chart series
 * @export
 * @interface DataPointDto
 */
export interface DataPointDto {
    /**
     * Label for this data point (e.g., "Jan", "Feb", "2024")
     * @type {string}
     * @memberof DataPointDto
     */
    label: string;
    /**
     * Numeric value for this data point
     * @type {number}
     * @memberof DataPointDto
     */
    value: number;
    /**
     * Order index for sorting (optional, uses array order if not provided)
     * @type {number}
     * @memberof DataPointDto
     */
    order?: number;
}

/**
 * Check if a given object implements the DataPointDto interface.
 */
export function instanceOfDataPointDto(value: object): value is DataPointDto {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function DataPointDtoFromJSON(json: any): DataPointDto {
    return DataPointDtoFromJSONTyped(json, false);
}

export function DataPointDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataPointDto {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'value': json['value'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function DataPointDtoToJSON(json: any): DataPointDto {
    return DataPointDtoToJSONTyped(json, false);
}

export function DataPointDtoToJSONTyped(value?: DataPointDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'value': value['value'],
        'order': value['order'],
    };
}

